import script from "./CallAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./CallAvatar.vue?vue&type=style&index=0&id=6a1eeed2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1eeed2"]])

export default __exports__